module.exports = __webpack_public_path__ + "static/img/home-house.0909435.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home-house.png
// module id = jnhZ
// module chunks = 0